const TEMPLATE_HEADERS = [
  'Year',
  'State',
  'County',
  'FIPS Code',
  'ZIP Code',
  'Rating Area',
]

export function downloadLocationTemplate(): void {
  const csv = TEMPLATE_HEADERS.join(',')
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'location-template.csv'
  link.click()
  URL.revokeObjectURL(url)
}
